import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../config";



export const getBlogs = createAsyncThunk(
  "blog/getAll",
  async () => {
    const response = await fetch(`${config.apiBaseUrl}/user-blog-show`, {
      method: "GET",
    });

    const result = await response.json();
    return result;
  }
);



export const getBlogById = createAsyncThunk(
  "blog/getOne",
  async (id) => {
    const response = await fetch(`${config.apiBaseUrl}/user-click-blog/${id}`, {
      method: "GET",
    });

    const result = await response.json();
    return result;
  }
);


const blogSlice = createSlice({
  name: "blog",
  initialState: {
    blogs: [],
    selectedBlog: null,
    status: "idle",
    detailStatus: "idle",
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getBlogs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getBlogs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.blogs = action.payload;
      })
      .addCase(getBlogs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(getBlogById.pending, (state) => {
        state.detailStatus = "loading";
      })
      .addCase(getBlogById.fulfilled, (state, action) => {
        state.detailStatus = "succeeded";
        state.selectedBlog = action.payload;
      })
      .addCase(getBlogById.rejected, (state, action) => {
        state.detailStatus = "failed";
        state.error = action.error.message;
      });
  },
});

export default blogSlice.reducer;
